import { render, staticRenderFns } from "./top-lang.vue?vue&type=template&id=866c6634&scoped=true&"
import script from "./top-lang.vue?vue&type=script&lang=js&"
export * from "./top-lang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866c6634",
  null
  
)

export default component.exports